<template>
  <v-card class="mb-6" :outlined="$vuetify.theme.dark">
    <v-list color="cardSurface" class="py-0">
      <v-list-group
        active-class="collapsable-bg"
        color="collapsableHeaderColor"
        v-model="openValue"
      >
        <template v-slot:prependIcon>
          <v-icon>{{ collapsibleIcon }}</v-icon>
        </template>
        <template v-slot:activator>
          <v-list-item-title>
            {{ collapsibleTitle }}
          </v-list-item-title>
          <v-responsive
            v-if="total !== null"
            class="
              caption
              text-center
              lightGrey
              rounded-circle
              d-inline-flex
              align-center
            "
            height="24"
            width="24"
          >
            {{ total }}
          </v-responsive>
        </template>
        <v-divider></v-divider>
        <v-card-text
          :class="{
            cardPaddingRemoved: !padding,
          }"
        >
          <slot></slot>
        </v-card-text>
      </v-list-group>
    </v-list>
  </v-card>
</template>

<script>
export default {
  props: {
    value: {
      type: Boolean,
      require: true,
    },
    padding: {
      type: Boolean,
    },
    collapsibleIcon: {
      type: String,
    },
    collapsibleTitle: {
      type: String,
    },
    total: {
      type: Number,
      default: null,
    },
  },
  computed: {
    openValue: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", value);
      },
    },
  },
};
</script>
<style lang="scss">
.collapsable-bg {
  background-color: var(--v-collapsableHeaderBG-base);
}
.cardPaddingRemoved {
  padding: 0;
  .cardStatusSideline {
    border-top-left-radius: 0 !important;
    border-top-right-radius: 0px !important;
    border-bottom-left-radius: 0px !important;
  }
}
</style>
